import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { InputMask } from '../../../../CommonComponents/OPL/Input/InputMask';
import { DraftAccountDTO } from '../../AccountOpening.meta';
import { EditableField } from '../../components/EditableField/EditableField';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { SpaceProps } from '../../../../theme/styledProps';
import { dobToForm } from './DateOfBirth.meta';

interface Props extends SpaceProps {
  isReview?: boolean;
  fieldName: string;
  draftAccount: DraftAccountDTO;
}

export const DateOfBirth: React.FC<Props> = ({ fieldName, isReview, draftAccount, ...rest }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const [isEditing, setIsEditing] = useState(!isReview);

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        {dobToForm(get(draftAccount, fieldName))}
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <InputMask
        {...register(fieldName)}
        label={isReview ? undefined : 'Date of Birth'}
        type="text"
        mask="99/99/9999"
        placeholder="MM/DD/YYYY"
        leftIcon="far fa-calendar-alt"
        formVariant={get(errors, fieldName) ? 'error' : undefined}
        helperText={get(errors, fieldName)?.message}
        autoComplete="bday"
        aria-label="Date of Birth"
      />
    </Box>
  );
};
